<!-- src/app/pages/guest-booking/guest-booking.component.html -->
<div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 py-8 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto">

    <!-- Header -->
    <div class="text-center mb-8">
      <mat-icon class="text-5xl text-blue-600 mb-4">hotel</mat-icon>
      <h1 class="text-4xl font-bold text-gray-900 mb-2">Crear Reserva</h1>
      <p class="text-lg text-gray-600">{{ organizationName() }}</p>
    </div>

    <!-- Success Message -->
    @if (submitSuccess()) {
      <mat-card class="mb-6 bg-green-50 border-l-4 border-green-500">
        <mat-card-content class="flex items-center">
          <mat-icon class="text-green-600 text-5xl mr-4">check_circle</mat-icon>
          <div>
            <h3 class="text-lg font-semibold text-green-800">¡Solicitud Enviada!</h3>
            <p class="text-sm text-green-700 mt-1">Recibirás un correo de confirmación y nos contactaremos contigo pronto.</p>
          </div>
        </mat-card-content>
      </mat-card>
    }

    <!-- PASO 0: DATOS BÁSICOS -->
    @if (Step === 0 && !submitSuccess()) {
      <mat-card class="shadow-xl">
        <mat-card-content class="p-6">
          <h2 class="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
            <mat-icon class="mr-2 text-blue-600">account_circle</mat-icon>
            Tu Información
          </h2>

          <form [formGroup]="guestForm" (ngSubmit)="continueToAvailability()" class="space-y-4">
            <!-- Email -->
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Correo Electrónico</mat-label>
              <input matInput type="email" formControlName="email" placeholder="tu@email.com">
              <mat-icon matSuffix>email</mat-icon>
              <mat-error>Ingresa un correo válido</mat-error>
            </mat-form-field>

            <!-- Teléfono -->
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Teléfono (Opcional)</mat-label>
              <input matInput formControlName="phone" placeholder="3001234567">
              <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>

            <!-- Nextinfo -->
            <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r">
              <p class="text-sm text-blue-800">
                <mat-icon class="align-middle">info</mat-icon>
                Usa este mismo email para recibir confirmaciones
              </p>
            </div>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              class="w-full py-3 text-lg">
              <mat-icon class="mr-2">arrow_forward</mat-icon>
              Continuar a Disponibilidad
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    }

    <!-- PASO 1: DISPONIBILIDAD -->
    @if (Step === 1 && !submitSuccess()) {
      <mat-card class="shadow-xl">
        <mat-card-content class="p-6">
          <h2 class="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
            <mat-icon class="mr-2 text-green-600">search</mat-icon>
            Buscar Disponibilidad
          </h2>

          <form [formGroup]="searchAvailabilityForm" class="space-y-6">
            <!-- Fechas -->
            <div>
              <h3 class="text-lg font-semibold text-gray-700 mb-4">Fechas de Estadía</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Check-in</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerIn"
                    formControlName="check_in"
                    [min]="minCheckInDate()"
                    placeholder="Fecha de entrada">
                  <mat-datepicker-toggle matSuffix [for]="pickerIn"></mat-datepicker-toggle>
                  <mat-datepicker #pickerIn></mat-datepicker>
                  <mat-error>Selecciona la fecha de entrada</mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Check-out</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerOut"
                    formControlName="check_out"
                    [min]="minCheckOutDate()"
                    placeholder="Fecha de salida">
                  <mat-datepicker-toggle matSuffix [for]="pickerOut"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOut></mat-datepicker>
                  <mat-error>Selecciona la fecha de salida</mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Huéspedes -->
            <div>
              <h3 class="text-lg font-semibold text-gray-700 mb-4">Número de Huéspedes</h3>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Adultos</mat-label>
                  <input matInput type="number" formControlName="adults" min="1" max="20">
                  <mat-icon matSuffix>person</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Niños</mat-label>
                  <input matInput type="number" formControlName="children" min="0" max="20">
                  <mat-icon matSuffix>child_care</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="fill" class="w-full">
                  <mat-label>Habitaciones</mat-label>
                  <input matInput type="number" formControlName="rooms" min="1" max="10">
                  <mat-icon matSuffix>bed</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <!-- Info de noches -->
            @if (numberOfNights() > 0) {
              <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r">
                <p class="text-sm text-blue-800">
                  <mat-icon class="align-middle">nights_stay</mat-icon>
                  <strong>{{ numberOfNights() }} {{ numberOfNights() === 1 ? 'noche' : 'noches' }}</strong>
                </p>
              </div>
            }

            <!-- Botón buscar -->
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="searchAvailability()"
              class="w-full py-3 text-lg">
              <mat-icon class="mr-2">search</mat-icon>
              Buscar Habitaciones
            </button>
          </form>

          <!-- SUGERENCIAS DE HABITACIONES -->
          @if (showSuggestions) {
            <mat-divider class="my-6"></mat-divider>

            <h3 class="text-xl font-semibold text-gray-800 mb-4">Sugerencias Disponibles</h3>

            @if (noRoomSuggestions) {
              <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-r">
                <p class="text-sm text-yellow-800">
                  <mat-icon class="align-middle">info</mat-icon>
                  No hay combinaciones de habitaciones disponibles para los criterios seleccionados.
                </p>
              </div>
            } @else {
              <div class="space-y-3">
                @for (suggestion of roomSuggestions; track suggestion.message) {
                  <div
                    class="p-4 border-2 rounded-lg cursor-pointer transition-all"
                    [class.border-green-500]="isSuggestionSelected(suggestion)"
                    [class.bg-green-50]="isSuggestionSelected(suggestion)"
                    [class.border-gray-300]="!isSuggestionSelected(suggestion)"
                    (click)="selectSuggestion(suggestion)">
                    <div class="flex justify-between items-start">
                      <div class="flex-1">
                        <p class="font-semibold text-gray-800">{{ suggestion.message }}</p>
                        <div class="text-sm text-gray-600 mt-2">
                          @for (room of suggestion.rooms; track room.id) {
                            <div class="flex items-center">
                              <mat-icon class="text-blue-600 mr-1">bed</mat-icon>
                              {{ room.name }} - Capacidad: {{ room.capacity }}
                            </div>
                          }
                        </div>
                      </div>
                      <div class="text-right">
                        <p class="text-lg font-bold text-green-600">
                          {{ formatCurrency(suggestion.totalPrice) }}/noche
                        </p>
                        @if (isSuggestionSelected(suggestion)) {
                          <mat-icon class="text-green-600">check_circle</mat-icon>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }

          <!-- Botones -->
          <div class="flex gap-2 mt-6">
            <button
              mat-raised-button
              color="accent"
              type="button"
              (click)="Step = 2"
              [disabled]="selectedRooms.length === 0"
              class="flex-1 py-3 text-lg">
              <mat-icon class="mr-2">arrow_forward</mat-icon>
              Continuar
            </button>
            <button
              mat-stroked-button
              type="button"
              (click)="Step = 0"
              class="py-3">
              <mat-icon>arrow_back</mat-icon>
              Atrás
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    }

    <!-- PASO 2: CONFIRMACIÓN -->
    @if (Step === 2 && !submitSuccess()) {
      <mat-card class="shadow-xl">
        <mat-card-content class="p-6">
          <h2 class="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
            <mat-icon class="mr-2 text-purple-600">verified</mat-icon>
            Confirmación de Reserva
          </h2>

          <!-- Resumen de datos -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <!-- Datos del Huésped -->
            <div class="bg-blue-50 p-4 rounded-lg">
              <h3 class="font-semibold text-gray-800 mb-2 flex items-center">
                <mat-icon class="mr-2 text-blue-600">person</mat-icon>
                Tu Información
              </h3>
              <p class="text-sm text-gray-700">{{ guestForm.get('email')?.value }}</p>
              <p class="text-sm text-gray-600">{{ guestForm.get('phone')?.value || 'Sin teléfono' }}</p>
            </div>

            <!-- Habitaciones -->
            <div class="bg-green-50 p-4 rounded-lg">
              <h3 class="font-semibold text-gray-800 mb-2 flex items-center">
                <mat-icon class="mr-2 text-green-600">bed</mat-icon>
                Habitaciones
              </h3>
              @for (room of selectedRooms; track room.id) {
                <p class="text-sm text-gray-700">{{ room.name }}</p>
              }
            </div>

            <!-- Fechas -->
            <div class="bg-orange-50 p-4 rounded-lg">
              <h3 class="font-semibold text-gray-800 mb-2 flex items-center">
                <mat-icon class="mr-2 text-orange-600">event</mat-icon>
                Fechas
              </h3>
              <p class="text-sm text-gray-700">
                {{ searchAvailabilityForm.get('check_in')?.value | date:'dd/MM/yyyy' }}
                a
                {{ searchAvailabilityForm.get('check_out')?.value | date:'dd/MM/yyyy' }}
              </p>
              <p class="text-xs text-gray-600 mt-1">{{ calculateNights() }} noches</p>
            </div>

            <!-- Huéspedes -->
            <div class="bg-purple-50 p-4 rounded-lg">
              <h3 class="font-semibold text-gray-800 mb-2 flex items-center">
                <mat-icon class="mr-2 text-purple-600">groups</mat-icon>
                Huéspedes
              </h3>
              <p class="text-sm text-gray-700">{{ totalGuests() }} {{ totalGuests() === 1 ? 'persona' : 'personas' }}</p>
              <p class="text-xs text-gray-600 mt-1">
                {{ searchAvailabilityForm.get('adults')?.value }} adultos,
                {{ searchAvailabilityForm.get('children')?.value }} niños
              </p>
            </div>
          </div>

          <!-- Servicios extras -->
          @if (extraServices.length > 0) {
            <mat-divider class="my-6"></mat-divider>

            <h3 class="text-lg font-semibold text-gray-800 mb-4">Servicios Extras</h3>
            <div class="space-y-3">
              @for (service of extraServices; track service.id) {
                <div class="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                  <div>
                    <p class="font-medium text-gray-800">{{ service.name }}</p>
                    <p class="text-sm text-gray-600">{{ formatCurrency(service.cost) }} c/u</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <button
                      mat-icon-button
                      (click)="decrementService(service.id)"
                      [disabled]="service.quantity === 0">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span class="w-8 text-center">{{ service.quantity }}</span>
                    <button
                      mat-icon-button
                      (click)="incrementService(service.id)">
                      <mat-icon>add</mat-icon>
                    </button>
                    <span class="w-24 text-right font-semibold">{{ formatCurrency(service.cost * service.quantity) }}</span>
                  </div>
                </div>
              }
            </div>
          }

          <!-- Resumen de costos -->
          <mat-divider class="my-6"></mat-divider>

          <div class="bg-gradient-to-r from-green-50 to-blue-50 p-4 rounded-lg space-y-2">
            <div class="flex justify-between">
              <span class="text-gray-700">Habitaciones ({{ calculateNights() }} noches):</span>
              <span class="font-semibold">{{ formatCurrency(calculateRoomTotal()) }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-700">Servicios extras:</span>
              <span class="font-semibold">{{ formatCurrency(calculateServicesTotal()) }}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="flex justify-between text-lg">
              <span class="font-bold text-gray-900">Total:</span>
              <span class="font-bold text-green-600">{{ formatCurrency(calculateTotal()) }}</span>
            </div>
          </div>

          <!-- Botones finales -->
          <div class="flex gap-2 mt-6">
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="onSubmit()"
              [disabled]="isLoading()"
              class="flex-1 py-3 text-lg">
              @if (isLoading()) {
                <ng-container>
                  <mat-icon class="mr-2 animate-spin">loop</mat-icon>
                  <span>Procesando...</span>
                </ng-container>
              } @else {
                <ng-container>
                  <mat-icon class="mr-2">send</mat-icon>
                  <span>Enviar Reserva</span>
                </ng-container>
              }
            </button>
            <button
              mat-stroked-button
              type="button"
              (click)="Step = 1"
              [disabled]="isLoading()"
              class="py-3">
              <mat-icon>arrow_back</mat-icon>
              Atrás
            </button>
          </div>

          <!-- Nota legal -->
          <p class="mt-6 text-xs text-gray-500 text-center border-t pt-4">
            🔒 Al enviar esta solicitud, aceptas que un miembro del equipo se contacte contigo para confirmar disponibilidad. Tus datos están protegidos.
          </p>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
